// extracted by mini-css-extract-plugin
module.exports = {"main":"CalculatorStatic_main__1quhB","mytestHeader":"CalculatorStatic_mytestHeader__1KeZr","editA":"CalculatorStatic_editA__1QF6_"};